export default "__VITE_ASSET__1PeHbtnW__"